import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import serializeStrapiParams from '../../utils/serializeStrapiParams';

const find = async (query) => {
  const { data } = await axiosInstance.get(endpoints.subcategories(), {
    params: query,
    paramsSerializer: (params) => serializeStrapiParams(params).join('&'),
  });
  return data;
};

const client = { find };

export default client;
